import React, { Component } from 'react';
import mixpanel, { initMixpanel } from '../utils/mixpanelConsent';
import Helmet from 'react-helmet';

import ProfileSettings from './ProfileSettings';
import AccountSettings from './AccountSettings';
import PaymentSettings from './PaymentSettings';
import NotificationSettings from './NotificationSettings';
import ShopSettings from './ShopSettings';
import AuthService from './AuthService';
import withAuth from './WithAuth';
import Layout from './Layout';
import constants from '../config';

import whitebox from './assets/White_square.png';

const Auth = new AuthService();
initMixpanel();

var TABS = [
  { key: 'profile', label: 'Profile', mobileLabel: 'Profile', icon: 'fa-user' },
  { key: 'account', label: 'Account', mobileLabel: 'Account', icon: 'fa-cog' },
  { key: 'payments', label: 'Payments & History', mobileLabel: 'Payments', icon: 'fa-credit-card' },
  { key: 'notifications', label: 'Notifications', mobileLabel: 'Alerts', icon: 'fa-bell' },
  { key: 'shop', label: 'Shop', mobileLabel: 'Shop', icon: 'fa-home' },
  { key: 'logout', label: 'Log Out', mobileLabel: 'Log Out', icon: 'fa-sign-out' },
];

class Settings extends Component {
  constructor() {
    super();
    this.state = {
      activeTab: 'profile',
      id: '',
      name: '',
      username: '',
      bio: '',
      profilePic: whitebox,
      backgroundPicture: whitebox,
      loading: true,
    };
    this.handleLogout = this.handleLogout.bind(this);
    this.handleProfilePicChange = this.handleProfilePicChange.bind(this);
    this.handleBackgroundPicChange = this.handleBackgroundPicChange.bind(this);
    this.handleProfileChange = this.handleProfileChange.bind(this);
    this.profile = this.profile.bind(this);
    this.setTab = this.setTab.bind(this);
  }

  componentDidMount() {
    this.profile(this.props.user._id);
    var params = new URLSearchParams(this.props.location && this.props.location.search);
    var tab = params.get('tab');
    if (tab && ['profile', 'account', 'payments', 'notifications', 'shop'].indexOf(tab) !== -1) {
      this.setState({ activeTab: tab });
    }
  }

  profile(userId) {
    Auth.fetch(constants.DOMAIN + '/api/v1/users/' + userId, {
      mode: 'cors',
      method: 'GET',
    }).then(function(res) {
      var strikeNotifs = (res.systemNotifications || []).filter(function(n) { return n.type === 'strike'; });
      this.setState({
        id: userId,
        name: res.profile.name,
        username: res.profile.userName,
        bio: res.profile.bio,
        profilePic: res.profile.image ? constants.DOMAIN + '/' + res.profile.image : whitebox,
        backgroundPicture: res.profile.backgroundPicture ? constants.DOMAIN + '/' + res.profile.backgroundPicture : whitebox,
        strikeNotifCount: strikeNotifs.length,
        loading: false,
      });
    }.bind(this))
    .catch(function(err) {
      console.log(err);
      this.setState({ loading: false });
    }.bind(this));
  }

  setTab(key) {
    if (key === 'logout') {
      this.handleLogout();
      return;
    }
    this.setState({ activeTab: key });
  }

  handleLogout() {
    mixpanel.track('Logout');
    Auth.logout();
    this.props.history.replace('/');
  }

  handleProfilePicChange(updatedUser) {
    this.setState({
      profilePic: updatedUser.picture ? constants.DOMAIN + '/' + updatedUser.picture : whitebox,
    });
  }

  handleBackgroundPicChange(updatedUser) {
    this.setState({
      backgroundPicture: updatedUser.backgroundPicture ? constants.DOMAIN + '/' + updatedUser.backgroundPicture : whitebox,
    });
  }

  handleProfileChange(name, username, bio) {
    this.setState({ name: name, username: username, bio: bio });
  }

  renderTabContent() {
    var tab = this.state.activeTab;
    if (tab === 'profile') {
      return (
        <ProfileSettings
          handleProfileChange={this.handleProfileChange}
          handleBackgroundPicChange={this.handleBackgroundPicChange}
          handleProfilePicChange={this.handleProfilePicChange}
          onSwitchTab={this.setTab}
          user={this.props.user}
        />
      );
    }
    if (tab === 'account') {
      return <AccountSettings user={this.props.user} strikeNotifCount={this.state.strikeNotifCount || 0} />;
    }
    if (tab === 'payments') {
      return <PaymentSettings user={this.props.user} />;
    }
    if (tab === 'notifications') {
      return <NotificationSettings user={this.props.user} />;
    }
    if (tab === 'shop') {
      return <ShopSettings user={this.props.user} />;
    }
    return null;
  }

  render() {
    var self = this;

    if (this.state.loading) {
      return (
        <Layout>
          <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center">
            <div className="tw-animate-spin tw-rounded-full tw-h-12 tw-w-12 tw-border-t-2 tw-border-b-2 tw-border-brand-gold"></div>
          </div>
        </Layout>
      );
    }

    return (
      <Layout>
        <Helmet>
          <title>Settings</title>
        </Helmet>
        <div className="tw-max-w-6xl tw-mx-auto tw-px-4 tw-py-8">
          <h1 className="tw-text-2xl tw-font-bold tw-text-[#111] dark:tw-text-white tw-mb-6">Settings</h1>
          <div className="tw-flex tw-gap-8">
            {/* Desktop Sidebar */}
            <aside className="tw-hidden md:tw-block tw-w-64 tw-flex-shrink-0">
              <div className="tw-rounded-xl tw-sticky tw-top-24 tw-bg-gray-100 dark:tw-bg-[#141414] tw-border tw-border-[#e0e0e0] dark:tw-border-[#333]" style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.06)', padding: '24px', paddingBottom: '32px' }}>
                {/* Avatar + Name */}
                <div className="tw-text-center tw-mb-6">
                  <img
                    src={this.state.profilePic}
                    alt="Profile"
                    className="tw-w-20 tw-h-20 tw-rounded-full tw-mx-auto tw-mb-3 tw-object-cover"
                    style={{ border: '3px solid #c9a84c' }}
                  />
                  <h3 className="tw-text-lg tw-font-semibold tw-text-[#111] dark:tw-text-white">{this.state.username}</h3>
                  <p className="tw-text-sm tw-text-[#888]">@{this.state.username}</p>
                </div>

                {/* Tab Navigation */}
                <div className="tw-space-y-1">
                  {TABS.map(function(tab) {
                    var isActive = self.state.activeTab === tab.key;
                    var isLogout = tab.key === 'logout';
                    return (
                      <button
                        key={tab.key}
                        onClick={function() { self.setTab(tab.key); }}
                        className={
                          'tw-w-full tw-text-left tw-px-4 tw-py-3 tw-rounded-lg tw-transition-all tw-duration-200 tw-flex tw-items-center tw-gap-3 tw-text-sm tw-font-medium tw-border-none tw-cursor-pointer ' +
                          (isActive
                            ? 'tw-bg-brand-gold/10 tw-text-brand-gold tw-border-l-2 tw-border-brand-gold'
                            : isLogout
                              ? 'tw-text-red-500 hover:tw-bg-red-500/10 tw-bg-transparent'
                              : 'tw-text-[#666] dark:tw-text-[#999] hover:tw-bg-[#e0e0e0] dark:hover:tw-bg-[#2a2a2a] tw-bg-transparent')
                        }
                      >
                        <i className={'fa ' + tab.icon} aria-hidden="true"></i>
                        {tab.label}
                        {tab.key === 'account' && self.state.strikeNotifCount > 0 && (
                          <span
                            className="tw-ml-auto tw-min-w-[20px] tw-h-5 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-bold tw-text-white tw-px-1"
                            style={{ backgroundColor: '#ef4444' }}
                          >
                            {self.state.strikeNotifCount}
                          </span>
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            </aside>

            {/* Mobile Tab Bar */}
            <div className="md:tw-hidden tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white dark:tw-bg-[#1a1a1a] tw-border-t tw-border-[#e0e0e0] dark:tw-border-[#333] tw-z-50 tw-flex mobile-tab-bar" style={{ padding: '6px 4px 2px', paddingBottom: 'max(2px, env(safe-area-inset-bottom))' }}>
              {TABS.map(function(tab) {
                var isActive = self.state.activeTab === tab.key;
                var isLogout = tab.key === 'logout';
                var activeColor = '#c9a84c';
                var inactiveColor = document.documentElement.classList.contains('tw-dark') ? '#8e8e93' : '#666';
                var color = isLogout ? '#ef4444' : isActive ? activeColor : inactiveColor;
                return (
                  <button
                    key={tab.key}
                    className="tab-shimmer"
                    onClick={function() { self.setTab(tab.key); }}
                    style={{
                      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                      flex: '1 1 0%', paddingTop: '4px', paddingBottom: '2px',
                      background: 'none', border: 'none', cursor: 'pointer',
                      textDecoration: 'none', color: color,
                      transition: 'color 200ms',
                    }}
                  >
                    <span style={{ position: 'relative', display: 'inline-block' }}>
                      <i className={'fa ' + tab.icon} style={{ fontSize: '18px', display: 'block' }} aria-hidden="true"></i>
                      {tab.key === 'account' && self.state.strikeNotifCount > 0 && (
                        <span
                          style={{
                            position: 'absolute', top: -4, right: -8,
                            fontSize: 9, width: 16, height: 16,
                            backgroundColor: '#ef4444', borderRadius: '50%',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            color: '#fff', fontWeight: 'bold',
                          }}
                        >
                          {self.state.strikeNotifCount}
                        </span>
                      )}
                    </span>
                    <span style={{ fontSize: '10px', marginTop: '2px', fontWeight: isActive ? '600' : '400', lineHeight: '1.2' }}>{tab.mobileLabel}</span>
                  </button>
                );
              })}
            </div>

            {/* Main Content */}
            <div className="tw-flex-1 tw-min-w-0 tw-pb-20 md:tw-pb-0">
              {this.renderTabContent()}
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

export default withAuth(Settings);
